export default function PhoneIcon({
	color = "white",
	size = 50,
}: {
	color: string;
	size: number;
}) {
	return (
		<svg
			aria-hidden="true"
			role="presentation"
			fill={color}
			viewBox="0 0 512 512"
			width={size}
			height={size}
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z" />
		</svg>
	);
}